import { Departamento } from './Departamento';
import { Distrito } from './Distrito';
import { PersonaXRepLeg } from './PersonaXRepLeg';
import { Provincia } from './Provincia';
import { TipoDocumento } from './TipoDocumento';

export class Persona {
  npersonaId: number;
  cpersonaNrodoc: string;
  // tslint:disable-next-line: ban-types
  npersonaIdtipdoc: number;
  cpersonaApepaterno: string;
  cpersonaApematerno: string;
  cpersonaNombres: string;
  dpersonaFnacimiento: Date;
  cpersonaRazonsocial: string;
  cpersonaDscreferencia: string;
  // cpersonaNroDoc : String;
  cpersonaDscdireccion: string;
  cpersonaDscreprelegal: string;
  cpersonaCprovdomic: string;
  cpersonaCdepartdomic: string;
  cpersonaCdistdomic: string;
  cpersonaCodsexo: string;

  cpersonaDsctelef: string;
  cpersonaDscmovil: string;
  cpersonaDsccorreo: string;
  cpersonaPrinommater: string;
  dpersonaFemidoc: Date;
  strDpersonaFemidoc: string;
  strDpersonaFnacimiento: string;

    numEdad: number;
    strCodSexo: string;
    listaPersonaPorReplegal: PersonaXRepLeg[];
    tipoDocumento: TipoDocumento;
    personaDepartdomic: Departamento;
    personaProvdomic: Provincia;
    personaDistrdomic: Distrito;

}
